import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import { loadStripe } from '@stripe/stripe-js'
import donateCommonMixin from '@/mixins/donations/donateCommonMixin.js'

export default {
  mixins: [ donateCommonMixin ],
  computed: {
    returnPageRoute() {
      return { name: 'FundraiserDonationReturnPublicPage', params: { fundraiserId: this.fundraiser.id, donationId: this.Donation.id } }
    }
  },
  async beforeUnmount() {
    console.log('Trying to cancel...')
    await this.cancelDonation()
  },
  methods: {
    async fetchClientSecret() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const response = await useFundraiserPublicStore().startDonation({
          name: this.DonationName,
          fundraiser_id: this.fundraiser.id,
          app_fee: this.DonationAppFeeAmount,
          amount: this.donationAmountToCharge,
          anonymous_name: this.DonationAnonymousName,
          anonymous_amount: this.DonationAnonymousAmount,
          comment: this.DonationComment,
          recurring: this.DonationRecurring,
          recurrences: this.DonationRecurrences
        })
        this.Donation = response.donation
        return response.payment_service.client_secret
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async startDonation() {
      if(this.StripeCheckoutObject) {
        await this.StripeCheckoutObject.destroy()
        this.DonationGatewayActive = false
      }
      const stripe = await loadStripe(import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY, {
        stripeAccount: this.fundraiser.payment_service.account_id,
      })

      this.DonationGatewayActive = true
      try {
        this.StripeCheckoutObject = await stripe.initEmbeddedCheckout({
          fetchClientSecret: this.fetchClientSecret,
          onComplete: async (complete) => {
            await this.StripeCheckoutObject.destroy()
            this.DonationGatewayActive = false
            this.DonationCompleted = true
            this.DonationAmount = null
            this.DonationTakeCareOfFees = false
            this.DonationAnonymousName = false
            this.DonationAnonymousAmount = false
            this.DonationShowCommentForm = false
            this.DonationComment = null
            this.StripeCheckoutObject = null
            this.$notify('Donation completed successfully!')
            if (this.Donation) {
              this.$router.push(this.returnPageRoute)
            }
          }
        });
        // Mount Checkout
        this.StripeCheckoutObject.mount('#checkout');
      }
      catch(e) {
        console.log(e, this.StripeCheckoutObject)
        await this.cancelDonation()
      }
    },
    async cancelDonation() {
      if(this.StripeCheckoutObject) {
        await this.StripeCheckoutObject.destroy()
        this.DonationGatewayActive = false
      }
    }
  }
}
